import React, { useState, useEffect, useCallback } from "react";
import { Button } from "antd";

import styled from "styled-components/macro";

const ArrowContainer = styled.div`
  position: absolute;
  width: auto;
  padding: 0 15px;
  height: 100%;
  top: 0;
  ${({ position }) => position}: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: 0.25s ease opacity;
  z-index: 10;
  ${({ visible }) =>
    visible &&
    `
    opacity: .5;
    pointer-events: unset;
    &:hover {
        opacity: 1;
    }

    `};
`;

function ScrollArrows({ containerRef }) {
  const [rightOverflow, setRightOverflow] = useState(false);
  const [leftOverflow, setLeftOverflow] = useState(false);

  const calculateArrows = useCallback(() => {
    if (containerRef.current) {
      const { scrollWidth, scrollLeft, clientWidth } = containerRef.current;
      setRightOverflow(scrollLeft + clientWidth < scrollWidth);
      setLeftOverflow(scrollLeft > 0);
    }
  }, [containerRef]);

  const scroll = px => {
    if (containerRef.current) {
      const { scrollWidth, scrollLeft } = containerRef.current;
      const left = Math.min(Math.max(scrollLeft + px, 0), scrollWidth);
      if (containerRef.current.scroll) {
        containerRef.current.scroll({
          behavior: "smooth",
          left
        });
      } else {
        containerRef.current.scrollLeft = left;
      }
    }
  };

  useEffect(() => {
    const ref = containerRef.current;
    if (ref && ref.scrollWidth > ref.clientWidth) {
      calculateArrows();
      ref.addEventListener("scroll", calculateArrows);
    }
    return () => {
      if (ref) {
        ref.removeEventListener("scroll", calculateArrows);
      }
    };
  }, [calculateArrows, containerRef]);

  return (
    <React.Fragment>
      <ArrowContainer position="left" visible={leftOverflow}>
        <Button
          size="large"
          shape="circle"
          icon="left"
          onClick={() => scroll(-500)}
        />
      </ArrowContainer>
      <ArrowContainer position="right" visible={rightOverflow}>
        <Button
          size="large"
          shape="circle"
          icon="right"
          onClick={() => scroll(500)}
        />
      </ArrowContainer>
    </React.Fragment>
  );
}

export default ScrollArrows;
